import { EffectIndex, KK, VK } from '@/define/define'
import { BaseDevice, CustomLayout, Dpi, initDpiColor, initDpiList } from '../base_device'
import icon from '@/assets/img/device/he3/he3_bg.png'
import board from '@/assets/img/device/he3/HE3.png'
import { generateArray } from '@/tool/utility'
import { mouseVKCodes } from '../keyboard/keycode/vkeycode'
import { DeviceType } from '@libs/types/enum'
import { LightEffectModeType } from '@/define/light'

export class He3SE extends BaseDevice {
  name: string = 'HE3_SE'
  icon: string = icon
  boardImage: string = board
  width: number = 207
  paddingX: number = 0
  paddingY: number = 0
  paddingBottom: number = 0
  texture = {}
  deviceType = DeviceType.mouse
  resetDes = ''
  // 不可操作
  inoperableKeys: KK[] = [0x0]
  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = {
    // '静态恒亮': 0x01,
    // '动态呼吸': 0x02,
    // '随波逐流': 0x03,
    // '光谱循环': 0x04,
  }
  vkcodes = mouseVKCodes

  absoluteKey: CustomLayout = {
    0x01: this.createSquare(104, 1, 93, 193),
    0x02: this.createSquare(87, 43, 33, 66),
    0x04: this.createSquare(1, 128, 13, 59),
    0x03: this.createSquare(4, 190, 15, 59),
  }
  mouseClass: { [index: KK]: string } = {
    0x01: 'right',
    0x02: 'middle',
    0x04: 'forward',
    0x03: 'back',
  }
  speedAllowValues: number[] = generateArray(0, 16)
  lightAllowValues: number[] = generateArray(0, 16)
  dpi: Dpi = {
    initList: initDpiList(),
    initListColor: initDpiColor(),
    length: 6,
    list: [
      400, 500, 600, 700, 800, 900, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900, 2000, 2100, 2200, 2300, 2400, 2500, 2600, 2700, 2800, 2900, 3000, 3100, 3200, 3300, 3400, 3500, 3600, 3700, 3800, 3900, 4000, 4100, 4200, 4300, 4400, 4500,
      4600, 4700, 4800, 4900, 5000, 5100, 5200, 5300, 5400, 5500, 5600, 5700, 5800, 5900, 6000, 6100, 6200, 6300, 6400,
    ],
    des: 'he2_dpi_des',
    isEdit: true,
    isColor: true,
  }
  rate: number[] = [0.125, 0.5, 1]
}
